import React, { Suspense, lazy, useMemo } from 'react';

import type {
	ExtensionKey,
	ExtensionManifest,
	ExtensionType,
} from '@atlaskit/editor-common/extensions/extension-manifest';
import type { ExtensionProvider } from '@atlaskit/editor-common/extensions/extension-provider';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { withExtensionManifest } from '../withExtensionManifest';

const iconWidth = '40px';
const itemIconStyles = xcss({
	width: iconWidth,
	height: iconWidth,
	overflow: 'hidden',
	border: `${token('border.width')} solid ${token('color.border')}`,
	borderRadius: token('radius.small', '3px'),
	boxSizing: 'border-box',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

type HeaderIconIconProps = {
	extensionManifest: ExtensionManifest;
};
function HeaderIcon({ extensionManifest }: HeaderIconIconProps) {
	const icon = extensionManifest.icons['48'];
	const title = extensionManifest.title;

	const ResolvedIcon = useMemo(() => {
		return lazy(() =>
			icon().then((Cmp) => {
				if ('default' in Cmp) {
					return Cmp;
				}
				return { default: Cmp };
			}),
		);
	}, [icon]);

	return (
		<Box xcss={itemIconStyles}>
			<Suspense fallback={null}>
				<ResolvedIcon label={title} />
			</Suspense>
		</Box>
	);
}

const _default_1: (props: {
	extensionKey: ExtensionKey;
	extensionProvider: ExtensionProvider;
	extensionType: ExtensionType;
}) => React.JSX.Element | null = withExtensionManifest(HeaderIcon);
export default _default_1;
